import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import PromoCodeAdmin from "views/admin/promo-code";
import FxProClientAdmin from "views/admin/fxpro-client";
import SlotVerificationAdmin from "views/admin/slot-verification";
import AdminSubscribers from "views/admin/subscribers";
import AdminClientSuggestions from "views/admin/client-suggestions";
import AdminMasterResults from "views/admin/master-results";
import MaintenanceAdmin from "views/admin/maintenance";
import AdminReferralContest from "views/admin/referral-contest";

// Icon Imports
import {
  MdHome,
  MdLocalOffer,
  MdVerified,
  MdPayment,
  MdOutlineLightbulb,
  MdGroups,
  MdShowChart,
  MdBuild,
  MdOutlineEmojiEvents,
} from "react-icons/md";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "PromoCode",
    layout: "/admin",
    path: "promo-code",
    icon: <MdLocalOffer className="h-6 w-6" />,
    component: <PromoCodeAdmin />,
  },
  {
    name: "FxPro Clients Verifications",
    layout: "/admin",
    path: "fxpro-client",
    icon: <MdVerified className="h-6 w-6" />,
    component: <FxProClientAdmin />,
  },
  {
    name: "Slot verification",
    layout: "/admin",
    path: "slot-verification",
    icon: <MdPayment className="h-6 w-6" />,
    component: <SlotVerificationAdmin />,
  },
  {
    name: "Contest",
    layout: "/admin",
    path: "Contest/RefferalContest",
    icon: <MdOutlineEmojiEvents className="h-6 w-6" />,
    component: <AdminReferralContest />,
  },
  {
    name: "Subscribers",
    layout: "/admin",
    path: "subscribers",
    icon: <MdGroups className="h-6 w-6" />,
    component: <AdminSubscribers />,
  },
  {
    name: "Client suggestions",
    layout: "/admin",
    path: "client-suggestions",
    icon: <MdOutlineLightbulb className="h-6 w-6" />,
    component: <AdminClientSuggestions />,
  },
  {
    name: "Maintenance",
    layout: "/admin",
    path: "maintenance",
    icon: <MdBuild className="h-6 w-6" />,
    component: <MaintenanceAdmin />,
  },
  {
    name: "Master results",
    layout: "/admin",
    path: "master-results",
    icon: <MdShowChart className="h-6 w-6" />,
    component: <AdminMasterResults />,
  },
];
export default routes;
